import { Entity } from '../../../../api';
import { EnrollmentEmailFormValues } from '../../types/forms';

export type RecipientType = 'unpaired' | 'groupOU';

export enum UserEmailType {
    AD = 'ad',
    CUSTOM = 'custom'
}

export type TokenType = 'silverfort' | 'thirdParty';

export interface SendEnrollmentEmailPopupState {
    selectedEntities: Entity[];
    formValues: EnrollmentEmailFormValues;
    isValid: boolean;
}
